import React, { Component } from 'react'
import { Input, Select, Spin, Table, Tooltip, message, Button, Divider, notification } from 'antd';
import { defaultDateFormat, showErrorInNotification, NetworkDelaySearch, copyStringToClipboard, formatMoney } from '../../lib/util';
import moment from 'moment';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { BasicHeader } from '../../components/basic_header';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { COLORS } from '../theme';
import { Link } from 'react-router-dom';
import { GetAppOutlined } from '@material-ui/icons';


const queryString = require('query-string');


const error_type_option = [
    {
        name: "Parser",
        value: "1"
    },
    {
        name: "Normalizer",
        value: "2"
    },
    // {
    //     name: "Classifier",
    //     value: "3"
    // },
    // {
    //     name: "Extractor",
    //     value: "4"
    // },
    // {
    //     name: "Enricher",
    //     value: "5"
    // }
]
class FileDetailError extends Component {
    constructor(props) {
        super(props)

        this.datatype = props.match.params.datatype_id;
        this.file_id = props.match.params.file_id;

        this.state = {
            filter_query: {
                per_page: 100,
                page: 1,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
            },
            loading: true,
            file_obj: {},
        }

        this.file_detail = RESTExecutor.detail().config({
            label: 'file_detail',
            params: {
                file_id: this.file_id
            }
        }).callbacks((success) => {
            this.setState({ loading: false, file_obj: success.result })
            // overrideHeaderTitle(`${success.result.name} | Files`);
            this.list_raw_data.forId(this.datatype).config({
                params: {
                    ...this.state.filter_query
                }
            }).execute();
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).forId(this.datatype).connect(props.domains.activity)



        this.list_raw_data = RESTExecutor.list().config({
            label: 'file_raws',
            params: {
            }
        }).forId(this.datatype).connect(props.domains.activity);

        this.reprocess_file = RESTExecutor.post().config({
            label: 'file_reprocess',
            params: {}
        }).callbacks((success) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            message.success(success.result.message || "Reprocessing File");
        }, (error) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            showErrorInNotification(error);
        }).connect(props.domains.activity);


        this.get_file_url = RESTExecutor.detail().config({
            label: 'file_download',
            params: {}
        }).callbacks((success) => {

            window.open(success.result.url, '_blank');
            try {
                this.loading_message();
            } catch (e) {

            }

        }, (error) => {
            showErrorInNotification(error);
            try {
                this.loading_message();
            } catch (e) { }

        }).connect(props.domains.activity);




    }
    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {

        const { filter_query, loading, file_obj } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }
        let list_raw_data_resp = this.list_raw_data.response();
        let file_detail_resp = this.file_detail.response();

        let list_raw_data_data = list_raw_data_resp.result || {};
        let rowsData = list_raw_data_data.rows || [];
        let rowsMeta = list_raw_data_resp.meta || {};

        return (
            <ErrorWrapper
                error={file_detail_resp}
                onReload={() => {
                    this.setState({
                        loading: true
                    }, () => {
                        this.file_detail.forId(this.datatype).execute()
                    })
                }}
            >
                <div>
                    <BasicHeader
                        title={file_obj.data_type}
                        titleType="Datatype"
                        subtitle={"File Detail"}
                    />
                    <div className='filter-card'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            paddingTop: 4, paddingBottom: 12
                        }}>
                            <span style={{
                                maxWidth: '70%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: 20,
                                color: '#000'
                            }}>
                                File : {file_obj.file_name}
                            </span>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                // justifyContent: 'center'
                            }}>
                                <Link to={`/activity/data-type/${this.datatype}/files/${this.file_id}/view`}>
                                    <Button title="View File"
                                        onClick={() => {
                                            // typeof props.onRerun==='function'&&props.onRerun(record)
                                        }}
                                        style={{
                                        }} type='link'>View File</Button>
                                </Link>
                                <Divider type='vertical' />

                                <Button title="Rerun"
                                    onClick={() => {
                                        if (file_obj.processed) {
                                            notification.warn({
                                                message: "You cannot re-run this file now."
                                            })
                                        } else {
                                            this.loading_message = message.loading(`Reprocessing ${file_obj.file_name}`, 0);
                                            this.reprocess_file.config({
                                                params: {
                                                    response_id: file_obj.fetcher_response_id,
                                                    file_id: this.file_id
                                                }
                                            }).execute();
                                        }
                                        // typeof props.onRerun==='function'&&props.onRerun(record)
                                    }}
                                    style={{
                                    }} type='link'>Re-run</Button>
                                <Divider type='vertical' />
                                <GetAppOutlined titleAccess="Download File"
                                    onClick={() => {
                                        this.loading_message = message.loading(`Downloading ${file_obj.file_name}`, 0);
                                        this.get_file_url.forId(this.datatype).config({
                                            params: {
                                                file_id: this.file_id,
                                                attachment: true
                                            }
                                        }).execute();
                                    }}
                                    className='basic-icon hand-cursor' />
                            </div>

                            {/* <Input.Search
                                placeholder="Input search text"
                                // enterButton
                                allowClear
                                autoFocus
                                value={filter_query.query}
                                style={{}}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault()
                                    this.stateUpdater({
                                        stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                                            this.delay_search.onSearch(() => {
                                                this.props.history.push({
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            })
                                        }
                                    });
                                }}
                            /> */}

                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            // justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            paddingTop: 4, paddingBottom: 4
                        }}>
                            <FilterFixedInput label="Status">
                                <Select
                                    allowClear
                                    showSearch
                                    className={filter_query.status != null ? 'filter-option-selected' : ''}
                                    style={{
                                    }}
                                    placeholder="Error / All"
                                    value={filter_query.status}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(value, e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            valueKey: 'status',
                                            value: value,
                                            callback: () => {
                                                this.props.history.push({
                                                    // pathname:"users",
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            }
                                        });
                                    }}
                                >
                                    <Select.Option value={'error'}>
                                        Error
                        </Select.Option>
                                    {/* <Select.Option value={'true'}>
                                        Transferred
                  </Select.Option> */}
                                </Select>
                            </FilterFixedInput>

                            <FilterFixedInput label="Level">
                                <Select
                                    allowClear
                                    showSearch
                                    className={filter_query.error_type != null ? 'filter-option-selected' : ''}
                                    style={{
                                    }}
                                    placeholder="Error / All"
                                    value={filter_query.error_type}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(value, e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            valueKey: 'error_type',
                                            value: value,
                                            callback: () => {
                                                this.props.history.push({
                                                    // pathname:"users",
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            }
                                        });
                                    }}
                                >
                                    {error_type_option.map((item) => {
                                        return <Select.Option value={item.value} key={item.value}>
                                            {item.name}
                                        </Select.Option>
                                    })}

                                    {/* <Select.Option value={'true'}>
                                        Transferred
                  </Select.Option> */}
                                </Select>
                            </FilterFixedInput>

                        </div>
                    </div>
                    <ErrorWrapper
                        error={list_raw_data_resp}
                        onReload={() => {
                            this.list_raw_data.execute()
                        }}
                    >
                        <div className='default-card' style={{
                            // margin:0
                        }}>
                            <Table
                                loading={list_raw_data_resp.fetching}
                                dataSource={rowsData}
                                className='main-table'
                                size='small'
                                columns={[
                                    {
                                        title: "RAW DATA",
                                        dataIndex: 'raw_txn',
                                        key: 'raw_txn',
                                        render: (value = {}) => JSON.stringify(value),
                                        width: 500
                                    },
                                    {
                                        title: "ERROR STATUS",
                                        width: 100,
                                        dataIndex: 'status',
                                        key: 'status',
                                        render: (status) => <div style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}
                                        >
                                            {status ?
                                                <Tooltip title={<div className='log-text'>
                                                    {(status || "")}
                                                </div>}
                                                    placement='bottomRight'
                                                    arrowPointAtCenter
                                                    autoAdjustOverflow
                                                    overlayClassName={status ? 'error-tooltip side-scroll' : ''}
                                                >
                                                    <div
                                                        onClick={(e) => {
                                                            copyStringToClipboard(status);
                                                            message.success("Copied")
                                                        }}
                                                        className='hand-cursor' style={{
                                                            height: 10, minHeight: 10,
                                                            width: 10, minWidth: 10,
                                                            borderRadius: 5,
                                                            backgroundColor: status ? COLORS.danger_primary : COLORS.success_primary,
                                                        }}>
                                                    </div></Tooltip>
                                                :
                                                <div style={{
                                                    height: 10, minHeight: 10,
                                                    width: 10, minWidth: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: status ? COLORS.danger_primary : COLORS.success_primary,
                                                }}>
                                                </div>
                                            }
                                        </div>,
                                        className: 'center-align'
                                    }
                                ]}
                                pagination={{
                                    simple: false,
                                    size: 'small',
                                    position: 'bottom',
                                    onChange: (current, size) => {
                                        this.props.history.push({
                                            search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                        })
                                    },
                                    defaultCurrent: 1,
                                    current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                    pageSize: (rowsMeta && rowsMeta.requested_count),
                                    total: (rowsMeta && rowsMeta.total_count),
                                    showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                                }}
                            />
                        </div>
                    </ErrorWrapper>
                </div>
            </ErrorWrapper>

        )
    }

    componentDidMount() {

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                file_id: this.file_id,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
                ...new_filter_query
            }
        }, () => {
            this.file_detail.execute()
            // this.list_raw_data.config({
            //     params: {
            //     ...this.state.filter_query
            //     }
            // }).execute()
        })

    }

    componentWillReceiveProps(nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        var oldfile_id = this.props.match.params.file_id;
        var newfile_id = nextProps.match.params.file_id;



        if (olddatatype_id !== newdatatype_id ||
            (oldfile_id !== newfile_id) || (
                this.props.location && (this.props.location.search !== nextProps.location.search)
            )) {
            this.datatype = newdatatype_id;
            this.file_id = newfile_id;

            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    file_id: this.file_id,
                    // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    // dateTo: moment().format(defaultDateFormat),
                    ...parsed
                },
            }, () => {
                if (olddatatype_id !== newdatatype_id || oldfile_id !== newfile_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.file_detail.forId(this.datatype).config({
                            params: {
                                file_id: this.file_id
                            }
                        }).execute()
                    })
                } else {
                    this.list_raw_data.forId(this.datatype).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }



            })

        }
    }
}

export default withDomains(FileDetailError, "activity")
